// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_gy-0";
export var headerCellHover = "_gy-1";
export var readCellContainer = "_gy-2";
export var unreadIndicator = "_gy-3";